<span 
    class="named-entity-thumb" 
    [class.named-entity-thumb--no-color]="!color"
    [style.backgroundColor]="color? (color | rgbToString:0.5) : ''"
    [matTooltip]="text.length > textPreview.length ? text : ''"
>{{ textPreview }}</span>
